import { useQuery } from '@tanstack/react-query';
import { parkingOptions } from '../../constants/parkings';
const DEFAULT_SCOPE = {
    withProperties: true,
    withImages: true,
    withSpots: true,
    withOpeningHours: true,
    withPackages: true,
};
export function useParking(slug, scope) {
    const { data, isLoading, isSuccess } = useQuery({
        ...parkingOptions.get({ slug: slug ?? '' }, scope ?? DEFAULT_SCOPE),
        enabled: !!slug,
    });
    return {
        parking: data?.[0],
        loadingParking: isLoading,
        isSuccess,
    };
}
